// extracted by mini-css-extract-plugin
export default {"inputLabel":"label_inputLabel__CGLTE","inputLabelSecondary":"label_inputLabelSecondary__6BGhy","inputGroup":"label_inputGroup__I4Wt3"};